import Script from "next/script";
export const CookieDeclaration = ({ slice: { primary }, className }) => primary.declaration_script ? (<div className={className}>
            <Script src={primary.declaration_script} type="text/javascript" async/>
            <div id="CookieDeclaration"/>
        </div>) : null;
